import React from 'react';
import { FaTrash, FaTag, FaUndo } from 'react-icons/fa';

const CompletedTodo = ({ id, text, color, onDelete, onReturn }) => {
  return (
    <div className="completed-todo">
      <div className="completed-todo__icon-wrapper" onClick={() => onReturn(id)}>
        <FaUndo className="red" />
      </div>
      <div className="completed-todo__content">{text}</div>
      <div className="completed-todo__actions">
        <FaTrash className="red" onClick={onDelete} />
        <FaTag className={color || 'grey'} />
      </div>
      <div className="completed-todo__date">Creation date: {new Date(id).toLocaleDateString()}</div>
    </div>
  );
};

export default CompletedTodo;
